// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'phone-out';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M9.28 16.963c1.383.87 3.128.653 4.22-.435l.509-.508a1.136 1.136 0 0 0 0-1.595l-2.037-2.031a1.144 1.144 0 0 0-1.6 0 1.144 1.144 0 0 1-1.6 0L5.57 9.203a1.136 1.136 0 0 1 0-1.596 1.136 1.136 0 0 0 0-1.595l-2.037-2.03a1.144 1.144 0 0 0-1.6 0l-.436.507c-1.164 1.16-1.31 2.9-.437 4.206 2.11 3.264 4.946 6.092 8.22 8.268zM17.5.5l-7.347 7.325M12.99.5h4.51v4.496'
  />
);

export const viewBox = '0 0 18 18';
